/**
 * Review Mapper
 * Maps between API DTOs and Domain Entities
 */

import {
  ReviewRequestDTO,
  PendingReviewsResponseDTO,
  MyReviewRequestsResponseDTO,
  CheckApprovedReviewResponseDTO,
} from "../models/ReviewDTOs";
import { ReviewRequestEntity } from "../../domain/entities/ReviewEntity";

export class ReviewMapper {
  /**
   * Convert ReviewRequestDTO to ReviewRequestEntity
   */
  static toReviewRequestEntity(dto: ReviewRequestDTO): ReviewRequestEntity {
    return {
      id: dto.id,
      userId: dto.user_id,
      reviewerId: dto.reviewer_id,
      moduleCode: dto.module_code,
      moduleName: dto.module_name,
      actionCode: dto.action_code,
      actionName: dto.action_name,
      entityType: dto.entity_type,
      entityId: dto.entity_id,
      status: dto.status,
      requestComments: dto.request_comments,
      reviewComments: dto.review_comments,
      reviewedAt: dto.reviewed_at,
      createdAt: dto.created_at,
      requesterName: dto.requester_name,
      reviewerName: dto.reviewer_name,
    };
  }

  /**
   * Convert PendingReviewsResponseDTO to ReviewRequestEntity array
   */
  static toReviewRequestEntityArray(
    dto: PendingReviewsResponseDTO
  ): ReviewRequestEntity[] {
    return (dto.data || []).map((reviewDto) =>
      this.toReviewRequestEntity(reviewDto)
    );
  }

  /**
   * Convert MyReviewRequestsResponseDTO to ReviewRequestEntity array
   */
  static toMyReviewRequestsEntityArray(
    dto: MyReviewRequestsResponseDTO
  ): ReviewRequestEntity[] {
    return (dto.data || []).map((reviewDto) =>
      this.toReviewRequestEntity(reviewDto)
    );
  }

  /**
   * Convert CheckApprovedReviewResponseDTO to ReviewRequestEntity or null
   */
  static toApprovedReviewEntity(
    dto: CheckApprovedReviewResponseDTO
  ): ReviewRequestEntity | null {
    if (dto.data.approved && dto.data.review) {
      return this.toReviewRequestEntity(dto.data.review);
    }
    return null;
  }
}
